export default "__VITE_ASSET__DvkhN4l3__"